import HijabStore from './HijabStore';

export default function App() {
  return <HijabStore />;
}